import { createStatusCellRenderer } from '@fortem-monorepo/react-ag'
import { Spinner } from '@fortem-monorepo/react-ui'

export const ScheduledTaskStatusCellRenderer = createStatusCellRenderer({
  success: { label: 'Completed', values: [2] },
  inProgress: { label: 'running...', values: [0], icon: <Spinner size={16} /> },
  error: { label: 'Failed', values: [1] },
})
